import Login from "./Pages/Login";
import MapBox from "./Pages/MapBox";
import UsersDashboard from "./Pages/UsersDashboard";
import ContractsDashboard from "./Pages/ContractsDashboard";

import { StateProvider } from "./Context/Store";
import {
  Route,
  Switch,
  BrowserRouter as Router,
} from "react-router-dom";

function App(props) {
  return (
    <StateProvider>
      <Router>
        <Switch>
          <Route exact path="/login" component={(props) => (<Login {...props} />)} />
          <Route exact path="/admin/users" component={(props) => (<UsersDashboard {...props} />)} />
          <Route exact path="/admin/contracts" component={(props) => (<ContractsDashboard {...props} />)} />
          <Route exact path="/" component={(props) => (<MapBox {...props} />)} />
        </Switch>
      </Router>
    </StateProvider>
  );
}

export default App;
